import React, { useRef } from 'react'
import s from '../../../styles/Form.module.scss'
import '../../../styles/buttons.scss'
import { GoogleLogin } from '../GoogleLogin/GoogleLogin'
import { ReactComponent as OpenedIcon } from '../../../../assets/icons/openedEye.svg'
import { ReactComponent as ClosedIcon } from '../../../../assets/icons/closedEye.svg'
import { useDomAutofill } from '../../hooks/useDomAutofill'

export const EmailLogin = ({
	loading,
	authAction,
	onLogin,
	email,
	setEmail,
	emailValid,
	password,
	setPassword,
	onGoogleLogin,
	googleExplanation,
	isVisiblePassword,
	setIsVisiblePassword,
	onForgotPassword,
}) => {
	const busy = Boolean(loading)
	const loginBusy = authAction === 'email'
	const loginDisabled = busy || !emailValid
	const emailRef = useRef(null)
	const passwordRef = useRef(null)
	const onAutofill = useDomAutofill([
		{ ref: emailRef, value: email, setValue: setEmail },
		{ ref: passwordRef, value: password, setValue: setPassword },
	])

	return (
		<>
			<form onSubmit={onLogin} className={s.form}>
				<label htmlFor="email" className={s.label}>
					Email
				</label>
				<input
					id="email"
					name="email"
					type="email"
					value={email}
					ref={emailRef}
					onChange={e => setEmail(e.target.value)}
					onAnimationStart={onAutofill}
					autoComplete="username"
					placeholder="example@google.com"
					className={s.input}
					disabled={busy}
				/>
				<div className={s.label}>
					<label htmlFor="password">Password</label>
					<button
						className={s.forgot}
						type="button"
						onClick={onForgotPassword}
						disabled={busy}
					>
						Forgot password?
					</button>
				</div>
				<div className={s.password}>
					<input
						id="password"
						name="password"
						type={isVisiblePassword ? 'text' : 'password'}
						value={password}
						ref={passwordRef}
						onChange={e => setPassword(e.target.value)}
						onAnimationStart={onAutofill}
						autoComplete="current-password"
						required
						className={s.input}
						disabled={busy}
					/>
					<span
						className={s.password__icon}
						onClick={() => {
							if (busy) return
							setIsVisiblePassword(!isVisiblePassword)
						}}
					>
						{isVisiblePassword ? <ClosedIcon /> : <OpenedIcon />}
					</span>
				</div>
				<button
					type="submit"
					disabled={loginDisabled}
					aria-busy={loginBusy}
					className={`btn btn-primary ${loginBusy ? 'loading' : ''}`}
				>
					<span
						className={`btn__content ${loginBusy ? 'btn__content--busy' : ''}`}
					>
						Login
					</span>
					{loginBusy ? <span className="btn__spinner" aria-hidden="true" /> : null}
				</button>
			</form>
			<GoogleLogin
				onLogin={onGoogleLogin}
				loading={busy}
				busy={authAction === 'google'}
				disabled={!emailValid}
				explanation={googleExplanation}
			/>
		</>
	)
}
